module.exports = __webpack_public_path__ + "static/img/compose768_1.6a60ac7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/compose768_1.png
// module id = 10jb
// module chunks = 16